import { finish, error } from '../../../modules/competitions/actions/move';

import api from '../../../api';

export function request(dispatch, { id, sport, displayOrder }) {
    api.post('/competitions/' + id + '/move', { sport, displayOrder }).then(
        (competitions) => dispatch(finish(competitions)),
        ({ errors }) => dispatch(error(errors))
    );
}
